import React, {useEffect, useMemo} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";


const BosCards = ({data, bosTeams, boName, isLeader}) => {
  const labels = useMemo(() => [
    `${boName} registrados`,
    `${boName} por plantão`,
    `${boName} com flagrante`,
    `Participações indiretas`,
  ], [])
  const reportName = isLeader ? `${boName} dos subordinados` : boName

  useEffect(() => {
    const rows = [];
    rows.push(data.total_bos ?? 0);
    rows.push(data.bo_avg ?? 0);
    rows.push(data.bo_flagrant ?? 0);
    !isLeader && rows.push(bosTeams ?? 0);

    const labelsToExport = !isLeader ? labels : labels.filter(el => el !== `${boName} em que participou`);

    ReportUtils.createExportableTable(labelsToExport, rows, reportName);
  }, [data, isLeader]);

  return(
    <>
      <div className="report-divisor">
        <span className="divisor-title">{reportName.toUpperCase()}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="mb-1 mt-3 cursor-pointer" title={`Apenas ${boName} com status "Aprovado"`}>
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[0]}</h3><h2>{data.total_bos ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center" title="Gerados a partir de despachos">
            <div className="box">
              <h3>{labels[1]}</h3><h2>{data.bo_avg ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1 mt-3 cursor-pointer">
          <div className="text-center">
            <div className="box">
              <h3>{labels[2]}</h3><h2>{data.bo_flagrant ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>
      { !isLeader &&
        <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
          <div className="mb-1 mt-1 cursor-pointer" title="Apenas como integrante da guarnição">
            <div className="text-center">
              <div className="box">
                <h3>{labels[3]}</h3><h2>{bosTeams ?? 0}</h2>
              </div>
            </div>
          </div>
        </div>
      }

      <div className="chart-divisor"></div>
    </>
  )
}

export default BosCards;